(function(){
  'use strict';

  document.querySelectorAll('[data-section-id]').forEach(function(section){
    var jsonEl = document.querySelector('[data-product-json="' + section.dataset.sectionId + '"]');
    if(!jsonEl) return;

    var productData;
    try { productData = JSON.parse(jsonEl.textContent); } catch(e){ return; }

    var chips = section.querySelectorAll('[data-var]');
    var idInput = section.querySelector('[data-product-id-input]');
    var hiddenSelect = section.querySelector('[data-variant-select]');
    var priceTargets   = section.querySelectorAll('[data-bind="price"], [data-bind-current-price]');
    var compareTargets = section.querySelectorAll('[data-bind-compare-price]');
    var cartRow = section.querySelector('[data-cart-row]');
    var quoteBtn = section.querySelector('[data-quote-trigger]');

    function currentSelection(){
      var selections = [], seen = {};
      section.querySelectorAll('[data-var]').forEach(function(btn){
        if(btn.classList.contains('is-active') && !seen[btn.dataset.var]){
          seen[btn.dataset.var] = true;
          selections.push(btn.dataset.value);
        }
      });
      return selections;
    }

    function findVariant(selections){
      if(!productData || !productData.variants) return null;
      return productData.variants.find(function(v){
        return v.options.every(function(opt, i){
          return (opt || '').toString().toLowerCase() === (selections[i] || '').toString().toLowerCase();
        });
      });
    }

    function formatMoney(cents){
      return '$' + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Full description of what the buyer configured, used to pre-fill the
    // quote / inquiry / customization popups. Rebuilt on every variant click
    // so the popup always carries the mirror actually on screen.
    function selectionString(v){
      var s = productData.title || '';
      if (v.title && v.title !== 'Default Title') s += ' · ' + v.title;
      if (v.sku) s += ' · SKU ' + v.sku;
      if (v.price > 0) s += ' · ' + formatMoney(v.price);
      return s;
    }

    // The popup build fields start from the configured mirror. Size comes
    // from the Size/Dimension option; light temperature from a Light/Temp
    // option, any option value that looks like one, or the Claris SKU suffix
    // (-L3K / -L4K / -L5K / -3T). Mirrors the Liquid in the section, which
    // handles the initial render.
    function computePrefills(v){
      var size = '', temp = '';
      (productData.options || []).forEach(function(name, i){
        var nm = (name || '').toString().toLowerCase();
        var val = (v.options[i] || '').toString();
        if (!size && (nm.indexOf('size') !== -1 || nm.indexOf('dimension') !== -1)) size = val;
        if (!temp && (nm.indexOf('temp') !== -1 || nm.indexOf('light') !== -1)) temp = val;
      });
      if (!temp) {
        v.options.forEach(function(val){
          var lc = (val || '').toString().toLowerCase();
          if (!temp && (lc.indexOf('3000k') !== -1 || lc.indexOf('4000k') !== -1 || lc.indexOf('5000k') !== -1 || lc.indexOf('tri-temp') !== -1 || lc.indexOf('no led') !== -1 || lc === '3t')) {
            temp = val;
          }
        });
      }
      if (!temp && v.sku) {
        var sk = v.sku.toLowerCase();
        if (sk.indexOf('-l3k') !== -1) temp = '3000K';
        else if (sk.indexOf('-l4k') !== -1) temp = '4000K';
        else if (sk.indexOf('-l5k') !== -1) temp = '5000K';
        else if (sk.indexOf('-3t') !== -1) temp = 'Tri-Temp';
      }
      return { size: size, temp: temp };
    }

    function isMadeToOrder(v){
      var stockEl = section.querySelector('[data-bind-stock]');
      if (!v.available) return false;
      if (stockEl) {
        var mtoIds = (stockEl.dataset.mtoIds || '').split(',').filter(Boolean);
        if (mtoIds.indexOf(String(v.id)) !== -1) return true;
      }
      if (typeof v.inventory_quantity === 'number' && v.inventory_management === 'shopify' && v.inventory_quantity <= 0) {
        return true;
      }
      return false;
    }

    function syncVariant(){
      var v = findVariant(currentSelection());
      if(!v) return;
      if(idInput) idInput.value = v.id;
      if(hiddenSelect) hiddenSelect.value = v.id;

      var madeToOrder = isMadeToOrder(v);

      // A price of zero is a data state, not a message.
      priceTargets.forEach(function(el){
        if (v.price > 0) {
          el.textContent = formatMoney(v.price);
        } else {
          el.textContent = el.dataset.quoteLabel || 'Quote on request';
        }
      });
      compareTargets.forEach(function(el){
        if (v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = formatMoney(v.compare_at_price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      // NOTHING SAYS SOLD OUT, and made to order is never an add-to-cart
      // purchase. The cart row is hidden for zero-price, unsellable and
      // made-to-order variants alike, and the quote button is promoted to the
      // primary style so the buyer always has a live path forward.
      var sellable = v.available && v.price > 0 && !madeToOrder;
      if (cartRow) {
        cartRow.classList.toggle('is-hidden', !sellable);
      }
      if (quoteBtn) {
        quoteBtn.classList.toggle('btn-cart--ghost', sellable);
        // Made to order gets its own CTA wording: Inquire.
        var quoteLabel = quoteBtn.dataset.quoteLabel;
        var mtoLabel = quoteBtn.dataset.mtoLabel;
        if (quoteLabel && mtoLabel) {
          quoteBtn.textContent = madeToOrder ? mtoLabel : quoteLabel;
        }
      }

      // Keep every popup trigger's pre-fill in step with the configuration on
      // screen. The popups read these attributes at open time.
      var selStr = selectionString(v);
      var pf = computePrefills(v);
      [
        ['[data-quote-trigger]',         'data-quote-selection'],
        ['[data-inquiry-trigger]',       'data-inquiry-selection'],
        ['[data-customization-trigger]', 'data-customization-selection'],
        ['[data-where-trigger]',         'data-where-selection']
      ].forEach(function(pair){
        section.querySelectorAll(pair[0]).forEach(function(btn){
          btn.setAttribute(pair[1], selStr);
          btn.setAttribute('data-prefill-size', pf.size);
          btn.setAttribute('data-prefill-temp', pf.temp);
        });
      });

      // Stock indicator. Made-to-order variant ids are rendered server-side
      // into data-mto-ids because product JSON no longer exposes
      // inventory_quantity to the storefront.
      section.querySelectorAll('[data-bind-stock]').forEach(function(el){
        if (v.available) {
          el.textContent = madeToOrder ? (el.dataset.madeToOrderLabel || 'Made to order') : (el.dataset.inStockLabel || 'In stock');
          el.classList.remove('info__stock--out');
          el.classList.toggle('info__stock--mto', madeToOrder);
        } else {
          el.textContent = el.dataset.outOfStockLabel || 'Quote on request';
          el.classList.add('info__stock--out');
          el.classList.remove('info__stock--mto');
        }
      });

      // Details rows follow the selected variant. Rows are always in the DOM
      // (rendered server-side) and are shown or hidden per variant here.
      section.querySelectorAll('[data-bind-sku]').forEach(function(el){
        var row = el.closest('[data-sku-row]');
        if (v.sku) {
          el.textContent = v.sku;
          if (row) row.style.display = '';
        } else if (row) {
          row.style.display = 'none';
        }
      });
      section.querySelectorAll('[data-bind-barcode]').forEach(function(el){
        var row = el.closest('[data-barcode-row]');
        if (v.barcode) {
          el.textContent = v.barcode;
          if (row) row.style.display = '';
        } else if (row) {
          row.style.display = 'none';
        }
      });
      section.querySelectorAll('[data-bind-weight]').forEach(function(el){
        var row = el.closest('[data-weight-row]');
        if (v.weight && v.weight > 0) {
          el.textContent = v.weight + ' ' + (v.weight_unit || 'kg');
          if (row) row.style.display = '';
        } else if (row) {
          row.style.display = 'none';
        }
      });

      // Included-feature line (2026-09-04). Variant-accurate: the codes per
      // variant id are rendered server-side into data-feature-map from the
      // SKU, the spans toggle here, and the cart line-item property mirrors
      // the visible labels. Diamond ClearVision is product-level and stays.
      section.querySelectorAll('[data-bind-features]').forEach(function(el){
        var map = {};
        try { map = JSON.parse(el.dataset.featureMap || '{}'); } catch(e){}
        var codes = (map[String(v.id)] || '').split(',').filter(Boolean);
        var labels = [];
        el.querySelectorAll('[data-feature]').forEach(function(span){
          var code = span.dataset.feature;
          var on = code === 'GLASS' ? true : codes.indexOf(code) !== -1;
          span.hidden = !on;
          if (on) labels.push(span.dataset.label || span.textContent.trim());
        });
        el.classList.toggle('is-empty', labels.length === 0);
        var inc = el.querySelector('[data-bind-included]');
        if (inc) { inc.value = labels.join(' · '); inc.disabled = labels.length === 0; }
      });

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch(e){}
    }

    chips.forEach(function(b){ b.classList.remove('is-disabled', 'is-soldout'); b.disabled = false; });

    function eq(a, b){ return (a || '').toString().toLowerCase() === (b || '').toString().toLowerCase(); }

    function snapToVariant(selections, changedIdx){
      if (!productData || !productData.variants) return null;
      var exact = productData.variants.find(function(v){
        return v.options.every(function(opt, i){ return eq(opt, selections[i]); });
      });
      if (exact) return exact;
      var candidates = productData.variants.filter(function(v){
        return eq(v.options[changedIdx], selections[changedIdx]);
      });
      if (!candidates.length) return null;
      var best = null, bestScore = -1;
      candidates.forEach(function(v){
        var score = 0;
        v.options.forEach(function(opt, i){
          if (i === changedIdx) return;
          if (eq(opt, selections[i])) score++;
        });
        if (v.available) score += 0.5;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }

    // Colour temperature descriptor (2026-09-04): the header value mirrors
    // the active swatch, Kelvin first, the word after it in a lighter weight.
    function setBoundValue(el, btn){
      el.textContent = btn.dataset.value;
      if (btn.dataset.desc) {
        var d = document.createElement('span');
        d.className = 'swatch__desc';
        d.textContent = ' · ' + btn.dataset.desc;
        el.appendChild(d);
      }
    }

    function applyVariant(v){
      if (!v || !productData || !productData.options) return;
      v.options.forEach(function(optVal, i){
        var optName = productData.options[i];
        if (!optName) return;
        var optHandle = optName.toString().toLowerCase().replace(/\s+/g, '-');
        section.querySelectorAll('[data-var="' + optHandle + '"]').forEach(function(b){
          b.classList.toggle('is-active', eq(b.dataset.value, optVal));
        });
        var activeBtn = null;
        section.querySelectorAll('[data-var="' + optHandle + '"]').forEach(function(b){
          if (eq(b.dataset.value, optVal)) activeBtn = b;
        });
        section.querySelectorAll('[data-bind="' + optHandle + '"]').forEach(function(el){
          if (activeBtn) { setBoundValue(el, activeBtn); } else { el.textContent = optVal; }
        });
      });
    }

    chips.forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.dataset.var;
        var groupIdx = parseInt(btn.dataset.optionIndex, 10);
        section.querySelectorAll('[data-var="' + group + '"]').forEach(function(b){
          b.classList.toggle('is-active', b === btn);
        });
        section.querySelectorAll('[data-bind="' + group + '"]').forEach(function(el){
          setBoundValue(el, btn);
        });
        var sel = currentSelection();
        var v = snapToVariant(sel, groupIdx);
        if (v) applyVariant(v);
        syncVariant();
      });
    });

    // 2026-08-04: the server HTML renders the stock badge with no state class,
    // so Made to order painted green until the first variant click. One sync on
    // load applies info__stock--mto (and the rest is idempotent with the
    // server render).
    syncVariant();
  });

  // Gallery thumbs
  document.querySelectorAll('.gallery__thumb').forEach(function(btn){
    btn.addEventListener('click', function(){
      var section = btn.closest('section');
      section.querySelectorAll('.gallery__thumb').forEach(function(b){
        b.classList.toggle('is-active', b === btn);
      });
      section.querySelectorAll('.gallery__img').forEach(function(i){
        i.classList.toggle('is-active', i.dataset.mediaId === btn.dataset.mediaId);
      });
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function(b){
    b.addEventListener('click', function(){
      var input = b.parentElement.querySelector('input[type="number"]');
      var v = parseInt(input.value || '1', 10);
      v += b.dataset.qty === '+' ? 1 : -1;
      if(v < 1) v = 1;
      input.value = v;
    });
  });

  // Accordion
  document.querySelectorAll('.acc__head').forEach(function(head){
    head.addEventListener('click', function(){
      var open = head.parentElement.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Lightbox
  document.querySelectorAll('[data-action="zoom"]').forEach(function(zoom){
    zoom.addEventListener('click', function(){
      var section = zoom.closest('section');
      var lb = document.getElementById('lightbox-' + section.dataset.sectionId);
      var lbImg = document.getElementById('lightbox-img-' + section.dataset.sectionId);
      var active = section.querySelector('.gallery__img.is-active');
      if(lbImg && active) lbImg.innerHTML = active.innerHTML;
      if(lb){ lb.classList.add('is-on'); document.body.style.overflow = 'hidden'; }
    });
  });

  document.querySelectorAll('.lightbox').forEach(function(lb){
    function close(){ lb.classList.remove('is-on'); document.body.style.overflow = ''; }
    lb.addEventListener('click', function(e){
      if (e.target.closest('video, model-viewer, iframe')) return;
      close();
    });
    var btn = lb.querySelector('[data-close]');
    if(btn) btn.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  });

  // Lazy recommendations
  document.querySelectorAll('[data-product-recommendations]').forEach(function(el){
    var url = el.dataset.url;
    if(!url) return;
    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        obs.unobserve(el);
        fetch(url).then(function(r){ return r.text(); }).then(function(html){
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var fresh = tmp.querySelector('[data-product-recommendations]');
          if(fresh) el.innerHTML = fresh.innerHTML;
        }).catch(function(){});
      });
    }, { rootMargin: '200px' });
    io.observe(el);
  });
})();